<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Score Report</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="center" class="row-header">
            <h2>Course Selection</h2>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Course</div>
              <select  class="input input-select" @change="onChange($event,1)">
                <option v-for="(item, index) in instructorCoursesData" :key="index" :value="item.courseID">{{$helpers.translate(item.title , 'en')}}</option>
              </select>
            </div>
            <div style="width: 3.125rem" />
            <div style="width: 30%">
              <div class="input-label">Section</div>
              <select class="input input-select" @change="onChange($event,2)">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Semester</div>
              <select class="input input-select" @change="onChange($event,3)">
                <option>All</option>
              </select>
            </div>
            <div style="width: 3.125rem" />
            <div style="width: 30%">
              <div class="input-label">Academic year</div>
              <select class="input input-select" @change="onChange($event,4)">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center" class="modal-detail">
            <div style="width: 30%">
              <div class="input-label">Topic</div>
              <select class="input input-select" @change="onChange($event,5)">
                <option>All</option>
              </select>
            </div>
          </CRow>
          <CRow alignHorizontal="center">
            <div class="button button-icon button-green" @click="onClick()">
              Export Report
              <img src="@/assets/images/admin/Download.svg" class="icon icon-invert" />
            </div>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import courseReport from "../../components/adminComponent/reportandexport/courseReport";
import scoreReport from "../../components/adminComponent/reportandexport/scoreReport";
import userReport from "../../components/adminComponent/reportandexport/userReport";
import downloadexcel from "vue-json-excel";
import axios from "axios";
import { mapGetters } from "vuex";
import XLSX from "xlsx";

export default {
  name: "ReportAndExport",
  components: {
    courseReport,
    scoreReport,
    userReport,
    downloadexcel,
  },
  data() {
    return {
      courseID: "",
      section: "",
      semester: "",
      academinYear: "",
      topic: "",
      instructorCoursesData: [],
      dataExport: [],
      exportStatus: false
    };
  },
  computed: {
    ...mapGetters({
      getDataExport: "courses/getDataExport",
      instructorCoursesGetter: "courses/getInstructorsCourse",
    }),
  },
  watch: {
    getDataExport(val) {
      if(val){
        this.dataExport = val;
        this.setDataExport()
      }
    },
    instructorCoursesGetter(value) {
      this.instructorCoursesData = value;
    },
  },
  created() {
    this.$store.commit("language/setChangingSidebar", true);
    this.$store.dispatch("courses/fetchInstructorsCourse");
  },
  mounted() {
  },
  methods: {
    onChange(event, type) {
      if (type == 1) {
        this.courseID = event.target.value;
      } else if (type == 2) {
        this.section = event.target.value;
      } else if (type == 3) {
        this.semester = event.target.value;
      } else if(type == 4){
        this.academinYear = event.target.value;
      } else if(type == 5){
        this.topic = event.target.value;
      }
    },

    onClick(){
      let body = {
        courseId: "24081001",
        section: "18",
      };
      this.$store.dispatch("courses/fetchDataExport", body);
    },

    onExport(header) {
      var aoa = header;
      const dataWS = XLSX.utils.aoa_to_sheet(aoa);
      dataWS["!merges"] = [
        // Set the cell merge of A1-C1
        { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } }, // Fname
        { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // lname
        { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // Student ID
        { s: { r: 0, c: 5 }, e: { r: 2, c: 5 } }, // Section
        { s: { r: 0, c: 6 }, e: { r: 0, c: 45 } }, //allProgress

        { s: { r: 1, c: 1 }, e: { r: 2, c: 1 } }, //fname-th
        { s: { r: 1, c: 2 }, e: { r: 2, c: 2 } }, //fname-en
        { s: { r: 1, c: 3 }, e: { r: 2, c: 3 } }, //lname-th
        { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } }, //lname-en
        { s: { r: 1, c: 6 }, e: { r: 1, c: 9 } }, //ch1
        { s: { r: 1, c: 10 }, e: { r: 1, c: 13 } }, //ch2
        { s: { r: 1, c: 14 }, e: { r: 1, c: 17 } }, //ch3
        { s: { r: 1, c: 18 }, e: { r: 1, c: 21 } }, //ch4
        { s: { r: 1, c: 22 }, e: { r: 1, c: 25 } }, //ch5
        { s: { r: 1, c: 26 }, e: { r: 1, c: 29 } }, //ch6
        { s: { r: 1, c: 30 }, e: { r: 1, c: 33 } }, //ch7
        { s: { r: 1, c: 34 }, e: { r: 1, c: 37 } }, //ch8
        { s: { r: 1, c: 38 }, e: { r: 1, c: 41 } }, //ch9
        { s: { r: 1, c: 42 }, e: { r: 1, c: 45 } }, //ch10
      ];
      //Control cell width
      dataWS["!cols"] = [{wpx: 70,},{ wpx: 100,},{wpx: 100,},{wpx: 100,},{wpx: 100,},{wpx: 100,},{wpx: 100,},];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export.xlsx");
    },
   
    setDataExport() {
      if (this.dataExport.length > 0) {
        let mockHeader = [
          ["Student", "Firstname", null, "Lastname", null, "Section"],
          [null, "EN", "TH", "EN", "TH", null],
          [null, null, null, null, null, null],
        ];
        this.dataExport.forEach((element, index) => {
          //set header all progress
          if (index == 0) {
            let tmpNumber = "",
              countProgress = 0;
            element[0].progress.template.forEach((head, index) => {
              
              // if (index == 0) {
              //   tmpNumber = quiz.topicNumber;
              //   mockHeader[0].push("All Progress", null, null);
              //   mockHeader[1].push(element.progress[countProgress].topicName[1].value,null,null);
              //   mockHeader[2].push("Progress (100%)","Use times (Minutes)",quiz.type);
              //   countProgress++;
              // } else {
              //   if (tmpNumber == quiz.topicNumber) {
              //     mockHeader[0].push(null);
              //     mockHeader[1].push(null);
              //     mockHeader[2].push(quiz.type);
              //   } else {
              //     mockHeader[0].push(null, null, null);
              //     mockHeader[1].push(element.progress[countProgress].topicName[1].value,null,null);
              //     mockHeader[2].push("Progress (100%)","Use times (Minutes)",quiz.type);
              //     tmpNumber = quiz.topicNumber;
              //     countProgress++;
              //   }
              // }
            });
          }
        });


        // let mockData = [];
        // this.dataExport.forEach((element, index) => {
        //   let student = [];
        //   student.push(element.userCode); //StudentID
        //   student.push(element.userfname[0].val); //fname EN
        //   student.push(element.userfname[1].val); //fname TH
        //   student.push(element.userlname[0].val); //lname EN
        //   student.push(element.userlname[1].val); //lname TH
        //   student.push(element.section); //section

        //   // set data all progress
        //   element.progress.forEach((topic, index) => {
        //     student.push(topic.progress);
        //     student.push(topic.useTime);
        //     element.quiz.forEach((quiz, index) => {
        //       if(quiz.topicNumber == topic.topicNumber){
        //         student.push(quiz.score+'/'+quiz.allScore)
        //       }
        //     });
        //   });

        //   // set all data together
        //   mockData.push(student);
        //   mockHeader.push(student);
        // });
        // this.onExport(mockHeader);
      }
    },
   
    dataExcel() {
      return this.dataExport;
    },
    async fetchData() {
      return this.dataExport;
    },
    startDownload() {
      alert("show loading");
    },
    finishDownload() {
      alert("hide loading");
    },
  },
};
</script>

<style>
</style>